import { useCallback } from 'react';
import { RateSheetGeneratorIndexResponse } from 'RtModels';
import { useGetRateSheetGenerators } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/services';
import {
	IRtxSelectInputInstanceProps,
	RtxSelectInput
} from 'RtUi/components/rtx/inputs/Select/RtxSelectInput';

export interface IRtxRateSheetGeneratorSelectProps<
	K extends keyof RateSheetGeneratorIndexResponse,
	IsMulti extends boolean = false,
	IsClearable extends boolean = false
> extends IRtxSelectInputInstanceProps<
		RateSheetGeneratorIndexResponse,
		K,
		IsMulti,
		IsClearable
	> {
	valueKey?: K;
}

export const RtxRateSheetGeneratorSelect = <
	K extends keyof RateSheetGeneratorIndexResponse,
	IsMulti extends boolean = false,
	IsClearable extends boolean = false
>({
	label = 'Label',
	valueKey,
	...props
}: IRtxRateSheetGeneratorSelectProps<K, IsMulti, IsClearable>): JSX.Element => {
	const { data: response, isLoading } = useGetRateSheetGenerators();
	const data = Array.isArray(response) ? response : response?.data ?? [];

	const formatOptionLabel = useCallback(
		(rsg: RateSheetGeneratorIndexResponse) => {
			return <span>{rsg.label}</span>;
		},
		[]
	);

	return (
		<RtxSelectInput<RateSheetGeneratorIndexResponse, K, IsMulti, IsClearable>
			label={label}
			valueKey={valueKey ?? ('label' as K)}
			labelKey="label"
			options={data}
			formatOptionLabel={formatOptionLabel}
			isLoading={isLoading}
			{...props}
		/>
	);
};
